export enum TeamTodosEvents {
    DELETE_TASK = 'task_deleted',
    CREATED_TASK = 'new_task',
    UPDATE = 'update_task',
    DONE = 'done_task'
}